module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container_com-fundo container_com-margem column dados-da-solicitacao borda",
    attrs: {
      "id": "visualizar-solicitacao"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "espacamento-interno visualizar-solicitacao"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "borda"
  }, [_c('h2', {
    staticClass: "titulo titulo_pequeno u-margem-inferior-media title is-5"
  }, [_vm._v("\n        Dados do Proponente\n      ")]), _vm._v(" "), _vm._l((_vm.proponentes), function(proponente, index) {
    return _c('div', [_c('span', {
      staticClass: "titulo titulo_pequeno"
    }, [_vm._v("\n          " + _vm._s(index + 1) + "º Proponente\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "field is-horizontal"
    }, [_c('div', {
      staticClass: "linha"
    }, [_c('div', {
      staticClass: "field coluna"
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Telefone || 'NÃO INFORMADO'))])])])]), _vm._v(" "), (proponente.Conjuge) ? _c('div', [_c('span', {
      staticClass: "titulo titulo_pequeno"
    }, [_vm._v("\n            " + _vm._s(index + 1) + "º Cônjuge\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "field is-horizontal"
    }, [_c('div', {
      staticClass: "linha"
    }, [_c('div', {
      staticClass: "field coluna"
    }, [_vm._m(6, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(7, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(8, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Telefone || 'NÃO INFORMADO'))])])])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "field-body field-body-linha"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._m(9), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.rendaTotalComprovada))])])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "borda u-margem-inferior-gigante"
  }, [_c('h2', {
    staticClass: "titulo titulo_pequeno u-margem-inferior-media title is-5"
  }, [_vm._v("\n        Dados do Imóvel\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.Construtora.Nome))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(11), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.Construtora.Cnpj))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(12), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Apf))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(13), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.Construtora.Conta))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(14), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Endereco.Cidade.Nome + ' - ' + _vm.imovel.Endereco.Cidade.EstadoSigla))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(15), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Endereco.Logradouro + ", " + _vm.imovel.Endereco.NumeroDoImovel))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(16), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Endereco.Cep))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(17), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Endereco.Bairro) + ", " + _vm._s(_vm.imovel.Endereco.Complemento))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(18), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.Nome))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(19), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Empreendimento.TipoDeEmpreendimento))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(20), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.valorDaCompraEVenda))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(21), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.valorDoFinanciamentoAprovado))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(22), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subsidioDoGovernoFederal))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(23), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subsidioDaAgehab))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(24), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.descontoDaConstrutora))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(25), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.participacaoDoSolicitante))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(26), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Matricula))])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "no-print botao botao_medio botao_cinza u-margem-direita-pequena",
    class: {
      'is-disabled': _vm.loading.visivel
    },
    attrs: {
      "to": {
        name: 'ListaDeSolicitacoes'
      }
    }
  }, [_vm._v("Voltar\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "ativo": _vm.loading,
      "altura": '60px',
      "largura": '60px'
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logos print has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/imagens/logo-relatorio-retrato.jpg"),
      "width": "100%",
      "alt": "Logo AGEHAB/SEILOG"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-body-linha"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-esquerda-pequena title is-5 print titulo-relatorios"
  }, [_vm._v("\n        Solicitação de subsídio\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "titulo titulo_grande u-margem-inferior-pequena u-margem-esquerda-pequena title is-5 no-print titulo-relatorios"
  }, [_vm._v("\n        Solicitação de subsídio\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio",
    attrs: {
      "type": "button",
      "onclick": "window.print()"
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Imprimir\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "texto-informativo u-margem-esquerda-pequena"
  }, [_c('span', {
    staticClass: "valor"
  }, [_vm._v("\n       Solicitação de Aporte de subsídio para contratação de financiamento habitacional dentro do programa Emendas Cidades conforme Portaria AGEHAB/MS nº 206 de 08 de maio de 2024\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Telefone: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Telefone: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Renda familiar comprovada:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Construtora:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CNPJ:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("APF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Conta vinculada:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Cidade:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Endereço:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CEP:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Bairro/Complemento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Empreendimento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Tipo de empreendimento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Valor de compra e venda:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Valor do financiamento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Subsídio do Governo Federal:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Subsídio da AGEHAB:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Desconto da construtora")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Participação do proponente:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Matrícula:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd04afcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacao-de-subsidio/McmvCidades/VisualizarSolicitacaoMcmv.vue
// module id = 1142
// module chunks = 1